<template>
    <div id="login">
      <div class="login-content">
        <div class="login-screen">
          <div class="left align-items-center justify-content-center">
            <img
              src="../assets/images/brands/holacon-logo.svg"
              height="48"
              alt=""
            />
            <div class="left-login-text">
              <div class="left-login-text-title text-info text-center">
               {{$t('auth.errorList.badGateway')}}
              </div>
              <div class="left-login-text-content text-center" v-html="$t('auth.errorList.badGatewayDesc', ['https://www.instagram.com/holaconapp/', 'Instagram'])">
                
              </div>
            </div>
            <div class="left-language-selector">
              <div
                class="left-language-option"
                @click="changeLocale('tr')"
                :class="{active: $i18n.locale == 'tr'}"
              >
                TR
              </div>
              <div
                class="left-language-option"
                @click="changeLocale('en')"
                :class="{active: $i18n.locale == 'en'}"
              >
                EN
              </div>
            </div>
          </div>
  
          <div class="right"></div>
        </div>
      </div>
    </div>
  </template>
  
  <script>
    import axios from "axios";
    import moment from "moment/min/moment-with-locales";
    export default {
      name: "Maintenance",
      metaInfo: {
        title: "Maintenance",
      },
      data() {
        return {
          form: {
            email: null,
            password: null,
          },
          loading: false,
          validationErrors: [],
          localStorage,
          moment,
          timeout: null,
        };
      },
      mounted() {
        setInterval(async ()=> {
         var res = await this.$store.dispatch('getEventCategories');
         if(res.status == 200){
          this.$router.push({name:'myevents'});
         }
        },5000)
      },
      methods: {
     
    
        
      },
    };
  </script>
  
  <style lang="less" scoped>
    .lang {
      width: 10px;
      height: 10px;
      font-size: 12px;
      display: inline-flex;
      justify-content: center;
      align-items: center;
    }
  
    .el-button + .el-button {
      margin-left: 2px;
    }
    #login {
      & > .login-content {
        width: 100%;
        height: 100vh;
        background-image: url("../assets/images/backgrounds/login-bg.png");
        background-repeat: no-repeat;
        background-position: center bottom;
        background-size: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
        .login-screen {
          background-color: white;
          border-radius: 1rem;
          max-width: 900px;
          width: 50%;
          display: flex;
  
          overflow: hidden;
          filter: drop-shadow(0px 2px 10px rgba(41, 47, 59, 0.1));
          min-height: 690px;
          height: auto;
          .left {
            width: 600px;
            display: flex;
            flex-direction: column;
            gap: 32px;
            padding: 4rem;
            min-height: 690px;
            // <div class="left-login-text">
            //     <div class="left-login-text-title"></div>
            //     <div class="left-login-text-content"></div>
            //   </div>
            .left-login-text {
              display: flex;
              flex-direction: column;
              gap: 8px;
              .left-login-text-title {
                font-style: normal;
                font-weight: 600;
                font-size: 28px;
                line-height: 36px;
                color: #292f3b;
                text-transform: capitalize;
              }
              .left-login-text-content {
                font-style: normal;
                font-weight: 400;
                font-size: 14px;
                line-height: 22px;
                color: #8c929c;
              }
            }
            .left-input-area {
              display: flex;
              flex-direction: column;
              gap: 16px;
              .input-box {
                display: flex;
                gap: 8px;
                flex-direction: column;
                label {
                  margin-bottom: 0;
                  font-style: normal;
                  font-weight: 400;
                  font-size: 14px;
                  line-height: 20px;
                  color: #505763;
                }
                .el-input {
                  input {
                    border: 1px solid #c8cdd3;
                    background-color: white !important;
                  }
                }
              }
            }
            .left-button-area {
              display: flex;
              align-items: center;
              & > div {
                font-weight: 500;
                font-size: 14px;
                line-height: 22px;
                letter-spacing: 0.2px;
                text-decoration-line: underline;
                cursor: pointer;
                color: #268ea6;
                max-height: 40px;
              }
  
              justify-content: space-between;
            }
            .left-register-reminder {
              font-style: normal;
              font-weight: 400;
              font-size: 14px;
              line-height: 22px;
              text-align: center;
              letter-spacing: 0.2px;
              span {
                font-weight: 500;
                color: #268ea6;
              }
            }
            .left-language-selector {
              max-width: 256px;
              width: 256px;
              height: 48px;
              align-self: center;
              background: #ffffff;
              padding: 8px;
              box-shadow: 0px 2px 10px rgba(41, 47, 59, 0.1);
              border-radius: 48px;
              display: flex;
              .left-language-option {
                width: 119px;
                height: 32px;
                font-weight: 700;
                font-size: 14px;
                line-height: 20px;
                display: flex;
                align-items: center;
                cursor: pointer;
                justify-content: center;
                text-align: center;
                letter-spacing: 0.2px;
                border-radius: 48px;
  
                transition: all 0.5s;
                &.active {
                  background: #268ea6;
                  color: white;
                  border-radius: 48px;
                }
              }
            }
          }
          .right {
            width: 300px;
            background-image: url("../assets/images/backgrounds/holacon-side-column-image.png");
            background-repeat: no-repeat;
            background-position: center center;
            background-size: cover;
            height: auto;
          }
        }
      }
    }
  </style>
  <style lang="less">
    .left-login-input-box {
      display: flex;
      gap: 8px;
      flex-direction: column;
      label {
        margin-bottom: 0;
        font-style: normal;
        font-weight: 400;
        font-size: 14px;
        line-height: 20px;
        color: #505763;
      }
      .el-input {
        input {
          border: 1px solid #c8cdd3;
          background-color: white !important;
        }
        .el-input__icon.fas {
          font-size: 13px;
          color: #268ea6;
          display: flex;
          align-items: center;
          justify-content: center;
        }
      }
    }
    .left-login-button {
      width: 196px;
      border: none;
      background: #268ea6 !important;
      & > span {
        display: flex;
        justify-content: center;
        gap: 11px;
        font-style: normal;
        font-weight: 600;
        width: 100% !important;
        font-size: 16px;
        align-items: center;
        & > i {
          font-size: 16px !important;
        }
      }
      color: #ffffff;
    }
  </style>
  


// WEBPACK FOOTER //
// src/pages/502.vue